<section>
  <div class="form-register">
    <form [formGroup]="formMaintenanceRoutineSupply">
      <div class="row p-1">
        <div class="col-lg-2 col-md-6 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles"
            [required]="true" [recovery]="true" [showExtraButton]="true" [titleExtraButton]="'Seleccionar Artículo'"
            [iconExtraButton]="'pi pi-external-link'" (onChangeSelect)="getArticle($event, true)"
            (clickExtraButton)="openArticleSelectionModal()"></app-custom-autocomplete>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantityEachUse" [labelText]="'C/Uso'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="maintenancePlanQuantity1"
            [labelText]="'PM1'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="maintenancePlanQuantity2"
            [labelText]="'PM2'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="maintenancePlanQuantity3"
            [labelText]="'PM3'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="maintenancePlanQuantity4"
            [labelText]="'PM4'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="maintenancePlanQuantity5"
            [labelText]="'PM5'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="maintenancePlanQuantity6"
            [labelText]="'PM6'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="maintenancePlanQuantity7"
            [labelText]="'PM7'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-5 col-sm-6 col-12 d-flex mt-2">
          <div class="d-flex align-items-end justify-content-end gap-1 container-buttons bottom-0">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>

    </form>
  </div>
</section>